import Vue from 'vue/dist/vue.esm.js'
import Router from 'vue-router'
import Buefy from 'buefy'
import 'buefy/lib/buefy.css'
import N3Components from 'N3-components'
import 'N3-components/dist/index.min.css'

// custom components
import Stats from '@/components/Stats'
import Users from '@/components/Users'
import Tests from '@/components/Tests'
import Devices from '@/components/Devices'
import Cars from '@/components/Cars'
import MainPage from '@/components/MainPage'
// import Cafes from '@/components/Cafes'

import MediaContainer from '@/components/MediaContainer'
Vue.component('media-uploader', MediaContainer)

Vue.use(Router)

Vue.use(Buefy, {
  defaultDayNames: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  defaultMonthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  defaultFirstDayOfWeek: 1
  // defaultDateParser: function (date) {
  //   console.log('dafaultDateParser', date)
  //   var d = new Date(Date.parse(date))
  //   return d
  // }
})

Vue.use(N3Components, 'en')

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Root',
      redirect: '/home'
    },
    {
      path: '/users',
      name: 'Users',
      component: Users
    },
    {
      path: '/tests',
      name: 'Tests',
      component: Tests
    },
    {
      path: '/devices',
      name: 'Devices',
      component: Devices
    },
    {
      path: '/cars',
      name: 'Cars',
      component: Cars
    },
    {
      path: '/stats',
      name: 'Stats',
      component: Stats
    },
    {
      path: '/home',
      name: 'home',
      component: MainPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js